<div class="content-seguridad">
  
  <!-- secciones-->
  <div class="component-seguridad">    
    <p class="ds-text-body-s-semi-bold">Solicitud de Pensión por Invalidez</p>
    <router-outlet></router-outlet>
  </div>
</div>